/**
 * Created by Armaldio on 11/01/2018.
 */
import BackButton from './BackButton'

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/BackButton/index.js